import {
    createAsyncThunk
} from '@reduxjs/toolkit';
import {
    api
} from '../../helpers/api_helper';
import {
    API_ENDPOINTS
} from '../../constants/apiEndPoints';


export const getLiveAds = createAsyncThunk('ads/getLiveAds', async ({ status, page = 1, limit = 6 }, thunkAPI) => {
    try {
        const response = await api.get(API_ENDPOINTS.ADS.GET_ALL, {
            status,
            page,
            limit
        });
        // console.log(response)
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

export const getAllAds = createAsyncThunk(
    'ads/getAllAds',
    async ({
        status,
        page = 1,
        limit = 6
    }, thunkAPI) => {
        try {
            // Build query parameters object
            const queryParams = {
                page,
                limit
            };
            // Add status filter if provided
            if (status && typeof status === 'object' && status.filter) {
                Object.assign(queryParams, status.filter);
            } else if (status && typeof status === 'string' && status !== 'all') {
                queryParams.status = status;
            }
            const response = await api.get(
                API_ENDPOINTS.ADS.GET_ALL,
                queryParams
            );
            console.log('response liveads' , response)
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);
export const getAllProfiles = createAsyncThunk('vendor/info', async ({ page = 1, limit = 6, status = null, filters = null, sort = null, created_at = null, filterState = null, forceRefresh = false }, thunkAPI) => {
    try {
        const queryParams = {
            page,
            limit
        };
        
        // Only add status if it's not null (i.e., not "All Profiles")
        if (status !== null) {
            queryParams.status = status;
        }
        
        // Add filters if provided
        if (filters && typeof filters === 'object' && filters.filter) {
            Object.assign(queryParams, filters.filter);
        } else if (filters && typeof filters === 'string' && filters !== 'all') {
            queryParams.status = filters;
        }
        
        // Add created_at sort parameter if provided
        if (created_at !== null) {
            queryParams.created_at = created_at;
        }
        
        // Add sort if provided (legacy support)
        if (sort && sort.sortOption) {
            queryParams.sort = sort.sortOption;
        }
        
        // Debug logging
        console.log('Query parameters being sent:', queryParams);
        console.log('Filter state:', filterState);
        
        const response = await api.get('/profile', queryParams);
        
        // Debug logging
        console.log('API Response:', response);
        console.log('Response data:', response.data);
        
        // Handle the API response structure based on actual backend response
        // Expected structure: { data: [...], total_count: N, total_pages: N, page: N, limit: N }
        let profilesData = [];
        let totalCount = 0;
        let totalPages = 0;
        let currentPage = page;
        let hasMorePages = false;
        
        if (response.data) {
            // The actual API response has this structure
            if (response.data && Array.isArray(response.data)) {
                profilesData = response.data;
                totalCount = response.total_count || 0;
                totalPages = response.total_pages || 0;
                currentPage = response.page || page;
                
                // Calculate hasMore based on total_pages
                hasMorePages = currentPage < totalPages;
            } 
            // Fallback for other possible response structures
            else if (Array.isArray(response.data)) {
                // Direct array response
                profilesData = response.data;
                totalCount = response.data.length;
                hasMorePages = false;
            } 
            else if (response.data.profiles && Array.isArray(response.data.profiles)) {
                // Nested profiles array
                profilesData = response.data.profiles;
                totalCount = response.data.total || response.data.total_count || 0;
                hasMorePages = profilesData.length === limit;
            }
        }
        
        console.log('Parsed data:', {
            profilesCount: profilesData.length,
            totalCount,
            totalPages,
            currentPage,
            hasMorePages
        });
        
        // Return structured data for caching with filterState
        return {
            data: profilesData,
            total: totalCount,
            totalPages: totalPages,
            page: currentPage,
            hasMore: hasMorePages,
            filters,
            filterState,
            sort
        };
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

export const getAnalyticsCount = createAsyncThunk('analytics/count', async (thunkAPI) => {
    try {
        const response = await api.get(API_ENDPOINTS.ANALYTICS.COUNT);
        console.log('Analytics API Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Analytics API Error:', error);
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
});

export const getAdPlan = createAsyncThunk('ads/plan', async (thunkAPI) => {
    try {
        const response = await api.get(API_ENDPOINTS.ADS.GET_AD_PLAN);
        // console.log('plan details', response.data)
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data)
    }
})

export const createAd = createAsyncThunk('ads/create', async (dataToSend, thunkAPI) => {
    try {
        const response = await api.create(API_ENDPOINTS.ADS.CREATE_AD, dataToSend);
        return response.data;
    } catch (error) {
        // console.error('Error in creating ad', error); // Log the entire error object
        if (error.response) {
            return thunkAPI.rejectWithValue(error.response.data);
        } else {
            return thunkAPI.rejectWithValue({
                error: error.message
            });
        }
    }
});

export const updateAd = createAsyncThunk('ads/update', async (dataToSend, thunkAPI) => {
    try {
        const response = await api.create(API_ENDPOINTS.ADS.UPDATE, dataToSend);
        return response.data;
    } catch (error) {
        if (error.response) {
            return thunkAPI.rejectWithValue(error.response.data);
        } else {
            return thunkAPI.rejectWithValue({
                error: error.message
            });
        }
    }
});

export const getBannerAds = createAsyncThunk('ads/getBannerAds', async (thunkAPI) => {
    try {
        const response = await api.get(API_ENDPOINTS.BANNER.GET);
        return response.data;
    } catch (error) {
        console.error('Banner API Error:', error);
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
});